import {Component, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {AppointmentDetailsComponent} from "../../components/appointment-details/appointment-details.component";
import {HeadlineWithIconComponent} from "../../../shared/components/headline-with-icon/headline-with-icon.component";
import {MatButton} from "@angular/material/button";
import {NgIf} from "@angular/common";
import {PreventDoubleClickDirective} from "../../../shared/directives/prevent-doublic-click-directive";
import {AppointmentModel} from "../../../core/models/appointment.model";
import {ActivatedRoute} from "@angular/router";
import {EmbedModeService} from "../../services/embed-mode.service";
import {FeedbackFormAcceptedComponent} from "../../components/feedback-form-accepted/feedback-form-accepted.component";
import {CommentModel} from "../../../core/models/comment.model";
import {AppointmentService} from "../../services/appointment.service";
import {TestRunService} from "../../services/test-run.service";
import {SnackBarService} from "../../../shared/services/snackbar.service";
import {ViessmannHomeBannerComponent} from "../../components/viessmann-home-banner/viessmann-home-banner.component";
import {SettingsModel} from "../../../core/models/settings.model";
import {
  ButtonHeatingSystemsOverviewComponent
} from "../../components/button-heating-systems-overview/button-heating-systems-overview.component";

@Component({
  selector: 'thank-you-page',
  templateUrl: './accepted.component.html',
  styleUrls: ['./accepted.component.scss'],
  standalone: true,
  imports: [MatCard, TranslateModule, AppointmentDetailsComponent, HeadlineWithIconComponent, MatButton, MatCardContent, NgIf, PreventDoubleClickDirective, FeedbackFormAcceptedComponent, ViessmannHomeBannerComponent, ButtonHeatingSystemsOverviewComponent]
})
export class AcceptedComponent implements OnInit {

  public appointment!: AppointmentModel;
  public settings!: SettingsModel;
  public embedModeEnabled: boolean = false;
  private isTestRun: boolean;

  constructor(
    private route: ActivatedRoute,
    private appointmentService: AppointmentService,
    private embedModeService: EmbedModeService,
    private testRunService: TestRunService,
    private snackBarService: SnackBarService,
  ) {
    this.isTestRun = this.testRunService.isTestRun();
  }

  ngOnInit() {
    this.appointment = this.route.snapshot.data['appointment'];
    this.settings = this.route.snapshot.data['settings'];
    this.embedModeEnabled = this.embedModeService.isEmbedModeEnabled();
  }

  closeFrameEvent() {
    this.embedModeService.closeFrameEvent();
  }

  receiveOutput(comment: CommentModel): void {
    if (comment) {
      this.appointmentService
        .addComment(this.appointment, comment, this.isTestRun)
        .subscribe(data => {
          this.snackBarService.showSuccess('APPOI.FEEDBACK_FORM.MESSAGE_SUCCESSFULLY_SENT');
        });
    }
  }

}
